import { TracingTransformer, TrackingData } from '@panamax/app-state';

export const notificationsTransformerFunc: TracingTransformer = (
  tracking: TrackingData,
) => ({
  ...tracking.data,
});
